import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import _ from 'lodash';
import Text from 'components/base/Text';
import { getColor } from 'common/constants/_colors';

const styles = () => {
  return {
    button: {
      display: 'block',
      marginTop: '1rem',
      borderBottom: 'none'
    },
    formControl: {
      margin: '0.5rem',
      backgroundColor: getColor('chambray', 0.2),
      borderRadius: '0.6rem'
    },
    input: {
      paddingTop: '1rem',
      paddingBottom: '1rem',
      paddingRight: '3rem',
      paddingLeft: '1rem'
    },
    notchedOutline: {
      borderColor: 'transparent'
    },
    outlinedRoot: {
      borderColor: 'transparent',
      borderWidth: 0,
      '&:hover $notchedOutline': {
        borderColor: 'transparent'
      },
      '&$focused $notchedOutline': {
        borderColor: 'transparent'
      }
    },
    iconOutlined: {
      top: 7,
      left: 7
    },
    focused: {},
    disabled: {
      opacity: 0.5
    }
  };
};

class ControlledSelect extends React.Component {
  state = {
    value: '',
    open: false
  };

  handleChange = event => {
    this.setState({ value: event.target.value });
    if (this.props.onChange) {
      this.props.onChange(event.target.value);
    }
  };

  handleClose = () => {
    this.setState({ open: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  handleOpen = () => {
    this.setState({ open: true });
    if (this.props.onOpen) {
      this.props.onOpen();
    }
  };

  componentDidMount() {
    if (this.props.defaultValue) {
      this.setState({
        value: this.props.defaultValue
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValue && nextProps.defaultValue !== this.state.value) {
      this.setState({
        value: nextProps.defaultValue
      });
    }
  }

  render() {
    const {
      classes,
      label,
      options,
      textSize = 'medium',
      disabled = false
    } = this.props;
    const instanceId = _.uniqueId();

    return (
      <form autoComplete='off'>
        <FormControl className={classes.formControl} variant='outlined'>
          {label ? (
            <OutlinedInput
              htmlFor={instanceId}
              classes={{
                input: classes.input,
                notchedOutline: classes.notchedOutline,
                root: classes.outlinedRoot,
                focused: classes.focused
              }}
            >
              {label}
            </OutlinedInput>
          ) : null}
          <Select
            data-cy='select'
            open={this.state.open}
            onClose={this.handleClose}
            onOpen={this.handleOpen}
            value={this.state.value}
            onChange={this.handleChange}
            input={
              <OutlinedInput
                labelWidth={5}
                name={instanceId}
                id={instanceId}
                classes={{
                  input: classes.input,
                  notchedOutline: classes.notchedOutline,
                  root: classes.outlinedRoot,
                  focused: classes.focused,
                  ...(disabled ? { disabled: classes.disabled } : {})
                }}
              />
            }
            inputProps={{
              name: instanceId,
              id: instanceId
            }}
            disabled={disabled}
          >
            {options.map(({ value, label, isDisabled = false }, idx) => {
              return (
                <MenuItem key={idx} value={value} disabled={isDisabled}>
                  <Text size={textSize} color='chambray'>
                    {label}
                  </Text>
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </form>
    );
  }
}

ControlledSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool
};

export default withStyles(styles)(ControlledSelect);
